import React from "react";
import { connect } from "react-redux";

import Snackbar from "material-ui/Snackbar";

// Action
import { hideSnackbar } from "../redux/modules/snackbar";

const CustomBar = props => (
  <Snackbar
    open={props.snackbar.open}
    autoHideDuration={3000}
    onClose={props.hideSnackbar}
    message={props.snackbar.message}
  />
);

const mapStateToProps = state => ({ snackbar: state.snackbar });

const mapDispatchToProps = dispatch => ({
  hideSnackbar: () => dispatch(hideSnackbar())
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomBar);



// WEBPACK FOOTER //
// ./src/containers/SnackbarContainer.js